/* Add new component CaseStudyTwoColumnsSubContent */

import React, { useState, useEffect } from 'react';
import style from './CaseStudyTwoColumnsSubContent.module.scss';
import Chart from '../Chart';
import { backgroundColorDefault } from '../Chart/chart_config';

const CaseStudyTwoColumnsSubContent = component => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    // Load data on component mount
    useEffect(() => {
        const loadData = async () => {
            try {
                setLoading(true);
                // Simulate API call delay
                await new Promise(resolve => setTimeout(resolve, 100));

                setData(component);
            } catch (error) {
                setData(null);
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, [component]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!data) {
        return null;
    }

    // Destructure data
    const { leftContents = [], rightContents = [] } = data;

    const textContent = rightContents && rightContents.find(item => item.type === 'newsDetailText');
    const featuresData = rightContents && rightContents.find(item => item.type === 'accentedFeatureList');

    const TextFormat = content => {
        return (
            <div className={style.textBlock}>
                {content && content.title && <h4 className={style.textTitle}>{content.title}</h4>}
                {content && content.body && (
                    <div
                        className={style.textBody}
                        dangerouslySetInnerHTML={{
                            __html: content.body,
                        }}
                    />
                )}
            </div>
        );
    };

    const renderLeftItem = (item, index) => {
        switch (item.type) {
            case 'chartItem':
                return (
                    <div key={index} className={style.chartSection}>
                        {item.chartType && (
                            <div className={style.chartContainer}>
                                <Chart
                                    chartType={item.chartType}
                                    dataset={item.dataset}
                                    hasLegend={
                                        item.chartType && item.chartType.toLowerCase() !== 'doughnut'
                                            ? item.hasLegend
                                            : false
                                    }
                                    title={item.title}
                                    options={{
                                        hover: {
                                            mode: null,
                                        },
                                    }}
                                />
                                {item.chartType &&
                                    item.chartType.toLowerCase() === 'doughnut' &&
                                    item.hasLegend &&
                                    item.dataset &&
                                    item.dataset.length > 0 && (
                                        <div className={style.legendBlock}>
                                            {item.dataset.map((dataItem, dataIndex) => (
                                                <div key={dataIndex} className={style.legendItem}>
                                                    <div
                                                        className={style.legendColor}
                                                        style={{
                                                            backgroundColor:
                                                                dataItem.color ||
                                                                backgroundColorDefault.backgroundColor[dataIndex] ||
                                                                '#cccccc',
                                                        }}
                                                    ></div>
                                                    <span className={style.legendText}>
                                                        {dataItem.dataKey || `Item ${dataIndex + 1}`}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                            </div>
                        )}
                        {!item.chartType && <div>Chart data missing chartType</div>}
                    </div>
                );
            case 'caseStudyImageNew':
                return (
                    item.image && item.image.url && (
                        <div key={index} className={style.leftImage}>
                            <img src={item.image.url} alt={item.image.alt || ''} />
                        </div>
                    )
                );
            case 'newsDetailText':
                return <TextFormat key={index} {...item} />;
            default:
                return null;
        }
    };
    return (
        <div className={[style.caseStudyTwoColumnsSubContent, 'container'].join(' ')}>
            <div className={style.twoColumnLayout}>
                {/* Left Column - Dynamic Content */}
                <div className={style.leftColumn}>
                    <div className={style.leftContent}>
                        {leftContents.map((item, index) => renderLeftItem(item, index))}
                    </div>
                </div>
                {/* Right Column - Text and Features */}
                <div className={style.rightColumn}>
                    <div className={style.rightContent}>
                        {/* Text Content */}
                        {textContent && <TextFormat {...textContent} />}

                        {/* Features List */}
                        {featuresData && featuresData.features && featuresData.features.length > 0 && (
                            <div className={style.featuresSection}>
                                <div className={style.featuresList}>
                                    {featuresData.features.map((feature, index) => (
                                        <div key={index} className={style.featureItem}>
                                            <div className={style.featureText}>{feature}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

CaseStudyTwoColumnsSubContent.propTypes = {
    // Component now receives all props directly
};

export default CaseStudyTwoColumnsSubContent;
